import styled from 'styled-components';

import { Avatar } from 'apps/components/shared';
import Heading from 'components/Heading';
import Button from 'components/Button';

import { media } from 'legacyComponents/styled/styleUtils';

export const MemberInfo = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const MemberText = styled.div`
  display: inline-block;
`;

export const ButtonStyled = styled(Button)`
  transition: opacity 200ms ease-in-out;
  margin-top: ${props => props.theme.spacing.default};
`;

export const MemberWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0px auto;
  padding: 30px 0px;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  opacity: ${props => (props.intrinsic ? '1' : '0.7')};
  ${ButtonStyled} {
    opacity: 0;
    pointer-events: none;
  }
  &:hover {
    ${ButtonStyled} {
      opacity: ${props => (props.intrinsic ? '1' : '0')};
      pointer-events: ${props => (props.intrinsic ? 'auto' : 'none')};
    }
  }
  ${media.s`
    width: 100%;
    padding: 20px 0px;
    ${ButtonStyled} {
      opacity: ${props => (props.intrinsic ? '1' : '0')};
      pointer-events: none;
      transform: scale(0.8);
    }
  `}
`;

export const CollaboratorAvatar = styled(Avatar)`
  display: inline-block;
  margin-right: 12px;
  ${media.s`
    width: 36px;
    height: 36px;
  `}
`;

export const Name = styled.h3`
  margin: 0px;
  font-size: 17px;
  ${media.s`
    font-size: 15px;
  `}
`;

export const Username = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  display: inline-block;
  cursor: pointer;
  /* FIXME: remove this override rule */
  &&& {
    margin: 0;
  }
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
  ${media.s`
    font-size: 12px;
  `}
`;

export const ButtonWrapper = styled.div``;

export const SectionTitle = styled(Heading)`
  padding-bottom: ${props => props.theme.spacing.default};
  color: ${props => props.danger && props.theme.color.wfOrange};
`;
